export const POSITION_TRENDS_ONBOARDING_STORAGE_KEY =
  'onboarding.positionTrends.v1.seen';

export type PositionTrendsOnboardingState = {
  isOpen: boolean;
  step: number;
  hasSeen: boolean;
  dismissed: boolean;
};

export const createPositionTrendsOnboardingState = (
  hasSeen: boolean,
): PositionTrendsOnboardingState => ({
  isOpen: false,
  step: 0,
  hasSeen,
  dismissed: false,
});

export const readPositionTrendsOnboardingSeen = (
  storage?: Storage | null,
): boolean => {
  if (!storage) {
    return false;
  }
  try {
    return storage.getItem(POSITION_TRENDS_ONBOARDING_STORAGE_KEY) === 'true';
  } catch (error) {
    return false;
  }
};

export const writePositionTrendsOnboardingSeen = (
  storage: Storage | null | undefined,
  seen = true,
) => {
  if (!storage) {
    return;
  }
  try {
    storage.setItem(POSITION_TRENDS_ONBOARDING_STORAGE_KEY, seen ? 'true' : 'false');
  } catch (error) {
    // Swallow storage errors to avoid breaking onboarding flow.
  }
};

export const getReplayPositionTrendsOnboardingState = (
  state: PositionTrendsOnboardingState,
): PositionTrendsOnboardingState => ({
  ...state,
  isOpen: true,
  step: 0,
  dismissed: false,
});

export const getClosePositionTrendsOnboardingState = (
  state: PositionTrendsOnboardingState,
): PositionTrendsOnboardingState => ({
  ...state,
  isOpen: false,
  dismissed: true,
});

export const getSkipPositionTrendsOnboardingState = (
  state: PositionTrendsOnboardingState,
): PositionTrendsOnboardingState => ({
  ...state,
  isOpen: false,
  hasSeen: true,
  dismissed: false,
  step: 0,
});

export const getDonePositionTrendsOnboardingState = (
  state: PositionTrendsOnboardingState,
): PositionTrendsOnboardingState => ({
  ...state,
  isOpen: false,
  hasSeen: true,
  dismissed: false,
  step: 0,
});
